import React from "react";
import { formatDateTime } from "./rootDashboardUtils";

export default function RootHeader({ lastUpdate, loading, onRefresh }) {
  return (
    <div className="management-card management-header root-header mb-4">
      <div>
        <p className="management-eyebrow mb-1">Root</p>
        <h4 className="management-title mb-1">Seguridad</h4>
        <p className="text-muted mb-0">Monitoreo de accesos y permisos.</p>
      </div>
      <div className="root-header-actions">
        <button
          className="btn root-refresh-btn"
          type="button"
          onClick={onRefresh}
          disabled={loading}
        >
          <i className="bi bi-arrow-repeat me-2" />
          {loading ? "Actualizando..." : "Actualizar"}
        </button>
        <small className="text-muted">
          Actualizado: {lastUpdate ? formatDateTime(lastUpdate) : "Sin datos"}
        </small>
      </div>
    </div>
  );
}
